var detect = avm.require('avast.detect');
var detecting = detect(); //Browser and OS detection, return following object

if (detecting.os.isWindows) {
	if (detecting.os.version === "10") {
		if (location.href !==  "https://www.avast.com/windows-10-antivirus") {
			$('.os-10').css("display","block");
		}	
	}
	else if (detecting.os.version === "8.1") {
	if (location.href !==  "https://www.avast.com/windows-8.1-antivirus") {
			$('.os-81').css("display","block");
		}
}
	else if (detecting.os.version === "8") {
	if (location.href !==  "https://www.avast.com/windows-8-antivirus") {
			$('.os-8').css("display","block");
		}
}
	else if (detecting.os.version === "7") {
	if (location.href !==  "https://www.avast.com/windows-7-antivirus") {
			$('.os-7').css("display","block");
		}
}
	else if (detecting.os.version === "XP") {
	if (location.href !==  "https://www.avast.com/windows-xp-antivirus") {
			$('.os-xp').css("display","block");
		}
}
	else if (detecting.os.version === "Vista") {
	if (location.href !==  "https://www.avast.com/windows-vista-antivirus") {
			$('.os-vista').css("display","block");
		}
}		
} 
else if (detecting.os.isMac) {
	
			$('.os-mac').css("display","block");
		
}
else if (detecting.os.isAndroid) {	
	
			$('.os-android').css("display","block");
	
}

